import React from 'react'
import DayPicker from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import Helmet from 'react-helmet'

import { addDays, endOfDay, format, isPast, parseISO, startOfDay } from 'date-fns'

import { Chevron } from '../../styles/global'
import { Container, Cell, DateText, Badge, Navbar, BadgeList } from './styles'

const DATE_FORMAT = 'yyyy-MM-dd HH:mm'
const MONTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro'
]

const Nav = ({ nextMonth, previousMonth, month, onChange }) => {
  return (
    <Navbar>
      <Chevron
        direction="left"
        fill="white"
        onClick={() => onChange(previousMonth)}
      />
      <h3>
        {MONTHS[month.getMonth()]} de {month.getFullYear()}
      </h3>
      <Chevron
        direction="right"
        fill="white"
        onClick={() => onChange(nextMonth)}
      />
    </Navbar>
  )
}

const Calendar = ({
  month,
  events = [],
  blocks = [],
  overbooks = [],
  onDayClick,
  onMonthChange
}) => {
  const renderDay = day => {
    const date = day.getDate()
    const isPastDate = isPast(endOfDay(day))

    const startOfCurrentDay = format(startOfDay(day), DATE_FORMAT)
    const nextDay = format(startOfDay(addDays(day, 1)), DATE_FORMAT)

    const isAllDayBlocked = blocks.some(({ start, end }) => start === startOfCurrentDay && nextDay === end)
    const blocksCount = blocks.filter(({ start }) => {
      const startDay = parseISO(start).getDate()
      return startDay === date
    })?.length
    const schedulingsCount = events.find(({ day }) => day === date)?.count || 0
    const overbooksCount = overbooks.find(({ day }) => day === date)?.count || 0

    const solicitationsCount = schedulingsCount + overbooksCount

    return (
      <Cell opaque={isPastDate}>
        <BadgeList>
          { solicitationsCount > 0 && (
            <Badge>{solicitationsCount}</Badge>
          )}
          { !isAllDayBlocked && blocksCount > 0 && (
            <Badge className='overlay-badge'>{blocksCount}</Badge>
          )}
          { isAllDayBlocked && (
            <Badge className='overlay-badge' blocked={isAllDayBlocked}></Badge>
          )}
        </BadgeList>
        <DateText>{date}</DateText>
      </Cell>
    )
  }

  return (
    <Container>
      <Helmet>
        <style>
          {`
          .DayPicker {
            width: 100%;
          }
          .DayPicker-wrapper {
            padding-bottom: 3px;
            border-radius: 5px;
          }
          .DayPicker-Month {
            margin: 0px;
            width: 100%;
          }
          .DayPicker-Day {
            padding: 0;
            border: 2px solid #2094A2;
            border-collapse: collapse;
          }
          .DayPicker-Day:first-of-type {
            border-left: 0;
          }
          .DayPicker-Day:last-of-type {
            border-right: 0;
          }
          .DayPicker-Day:hover {
            background-color: unset !important;
          }
          .DayPicker-Weekday {
            color: white;
            font-weight: bold;
          }

          @media screen and (max-width: 370px) {
            .DayPicker-Day {
              max-width: 45px;
            }
          }
          `}
        </style>
      </Helmet>
      <DayPicker
        month={month}
        months={MONTHS}
        weekdaysShort={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab']}
        navbarElement={<Nav onChange={onMonthChange} />}
        onDayClick={onDayClick}
        captionElement={() => null}
        renderDay={renderDay}
      />
    </Container>
  )
}

export default Calendar
